module.exports = __webpack_public_path__ + "static/banner@2x-0be2d7f429eb2fe003b93732b09760ee.jpg";